// extracted by mini-css-extract-plugin
export var bold = "_sh-0";